var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnlyPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    width: 360,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ArkhamLaw_Logo_Instagram_BOLD-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00235d } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Artboards_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m180.2 32c-82.8 0-150.1 67.3-150.1 150 0 41.6 17.1 79.2 44.5 106.4l0.4-1 0.1-0.1v-0.1l6-13.4c-22.4-24.1-36.1-56.4-36.1-91.8 0-74.5 60.6-135.2 135.2-135.2 74.5 0 135.1 60.7 135.1 135.2 0 74.5-60.6 135.1-135.1 135.1-25.5 0-49.3-7-69.6-19.3l-8.8 12.1c22.9 14 49.7 22.1 78.4 22.1 82.7 0 149.9-67.3 149.9-150 0-82.7-67.2-150-149.9-150z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m278.9 258.6c-3.6 6.4-8.6 10.6-13.6 13.8-4.4 2.9-14.3 6.8-14.3 6.8l-29.7-69.1 14.8-3 22.4 52.2c3.6-1.8 6.2-5.5 7.6-8 6.1-10.6 8.5-28.8 1.1-41.7-5-8.7-13.6-13-25.4-13-75.2 0-128.7 74.7-129.3 75.4l-38.7 53.3 106.4-240.7 45 98.2q8.2-1 16.6-1c17 0 30.5 7.2 38.1 20.4 10.4 18 7.4 42-1 56.4zm-68.6-73l-30.2-66.1-49.2 110.6c19-17.4 46.3-36.6 79.4-44.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyPrimary);
export default __webpack_public_path__ + "static/media/logo_only_primary.1c45471ca9c7d79ea8f490290fe78539.svg";
export { ForwardRef as ReactComponent };